// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Carousel2-carousel-6ea1{--pad: 24px;width:calc(64% + 2*var(--pad));height:100%}.Carousel2-stand-6ea1{--pad: 48px}`, "",{"version":3,"sources":["webpack://./src/page/InferenceScreen/Carousel/Carousel2.module.scss"],"names":[],"mappings":"AAAA,yBACE,WAAA,CAEA,8BAAA,CACA,WAAA,CAGF,sBACE,WAAA","sourcesContent":[".carousel {\n  --pad: 24px;\n\n  width: calc(64% + 2 * var(--pad));\n  height: 100%;\n}\n\n.stand {\n  --pad: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel": `Carousel2-carousel-6ea1`,
	"stand": `Carousel2-stand-6ea1`
};
module.exports = ___CSS_LOADER_EXPORT___;
